import { SubmitType } from '@/domain/enums/submit-type';
import { defineComponent, inject } from 'vue';
import SubmitButtonClass from './SubmitButton.class';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { setupComponent } from "@studyportals/vue-platform";

export default defineComponent({
	props: {
		type: String,
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	setup: (props, context) => {
		const store = inject<IIncentiveV2Store>('incentiveV2Store');
		if (!store) throw new Error('incentiveV2Store was not provided');
		const component = new SubmitButtonClass(store, props.type as SubmitType, context);
		return setupComponent(component);
	},
});
